/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_EnInputs */

const en_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const es_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const zh_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const ar_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const fr_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const vi_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const sw_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const th_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const bs_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const ja_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const ko_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const pt_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const it_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const sv_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const nl_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const da_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const nb_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const fi_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const pl_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const ru_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const tr_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const hi_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const id_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const ms_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const cs_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const el_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const he_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const af_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const hu_nav_language_en = /** @type {(inputs: Nav_Language_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Nav_Language_EnInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_en = /** @type {((inputs?: Nav_Language_EnInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_EnInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_en(inputs)
	if (locale === "de") return de_nav_language_en(inputs)
	if (locale === "zh") return zh_nav_language_en(inputs)
	if (locale === "ar") return ar_nav_language_en(inputs)
	if (locale === "fr") return fr_nav_language_en(inputs)
	if (locale === "vi") return vi_nav_language_en(inputs)
	if (locale === "sw") return sw_nav_language_en(inputs)
	if (locale === "th") return th_nav_language_en(inputs)
	if (locale === "bs") return bs_nav_language_en(inputs)
	if (locale === "ja") return ja_nav_language_en(inputs)
	if (locale === "ko") return ko_nav_language_en(inputs)
	if (locale === "pt") return pt_nav_language_en(inputs)
	if (locale === "it") return it_nav_language_en(inputs)
	if (locale === "sv") return sv_nav_language_en(inputs)
	if (locale === "nl") return nl_nav_language_en(inputs)
	if (locale === "da") return da_nav_language_en(inputs)
	if (locale === "nb") return nb_nav_language_en(inputs)
	if (locale === "fi") return fi_nav_language_en(inputs)
	if (locale === "pl") return pl_nav_language_en(inputs)
	if (locale === "ru") return ru_nav_language_en(inputs)
	if (locale === "tr") return tr_nav_language_en(inputs)
	if (locale === "hi") return hi_nav_language_en(inputs)
	if (locale === "id") return id_nav_language_en(inputs)
	if (locale === "ms") return ms_nav_language_en(inputs)
	if (locale === "cs") return cs_nav_language_en(inputs)
	if (locale === "el") return el_nav_language_en(inputs)
	if (locale === "he") return he_nav_language_en(inputs)
	if (locale === "af") return af_nav_language_en(inputs)
	if (locale === "hu") return hu_nav_language_en(inputs)
	return en_nav_language_en(inputs)
});